import persister from './persister'

export default [persister]



// WEBPACK FOOTER //
// ./src/store/enhancers/index.js